<template>
  <div class="table-item">
    <div class="title clearfix">
      <p class="pull-left userInfo">{{ title }}</p>
      <div class="pull-right">
        <slot name="tool"></slot>
      </div>
    </div>
    <div class="table">
      <el-table
        :data="tableData"
        stripe
        border
        style="width: 100%"
        :summary-method="summaryMethod"
        :show-summary="showSummary"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="100"> </el-table-column>
        <el-table-column type="index" width="100" label="序号"></el-table-column>
        <el-table-column
          :prop="item.field"
          :label="item.label"
          :width="columnWidth"
          v-for="(item, index) of columnData"
          :key="index"
        >
        </el-table-column>
        <slot name="other"></slot>
        <el-table-column fixed="right" label="操作" width="200" v-if="isEdit">
          <template slot-scope="scope">
            <el-button
              class="textBtn"
              @click.native.prevent="editRow(scope)"
              type="text"
              size="small"
              >{{ text }}</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
// 导航栏
const leftWidth = 250;
const cellWidth = 200;

export default {
  // props: ["title", "flag", "tableData", "columnData"],
  props: {
    title: String,
    flag: Number,
    tableData: Array,
    columnData: Array,
    isEdit: {
      default: true,
    },
    text: {
      default: "编辑",
    },
    summaryMethod: {},
    showSummary: {
      default: false,
    },
    isBackShow: {
      default: false,
    },
    isLookShow: {
      default: false,
    },
  },

  data() {
    return {
      isFundShow: false,
      showButton: true,
    };
  },

  computed: {
    columnWidth() {
      const width = document.body.clientWidth - leftWidth;
      const maxLength = width / cellWidth;
      if (maxLength >= this.columnData.length) return "auto";
      else return cellWidth;
    },
  },
  methods: {
    editRow(scope) {
      this.$emit("editTable", {
        flag: this.flag,
        scope,
      });
    },
    lookSubDetail(scope) {
      this.$emit("lookSubDetail", {
        flag: this.flag,
        scope,
      });
    },
    handleSelectionChange(val) {
      console.log("table.vueddd3 handleSelectionChange", val);
      if (val.length) {
        let ids = [];
        val.forEach((item) => {
          ids.push(item.id);
        });
        this.$emit("handleSelectionChange", ids.join(","), this.flag);
      }
      this.$emit("handleSelectionCode", val);
    },
    //查看详情
    lookDetail(scope) {
      const codeId = scope.row.id;
      this.isFundShow = true;
      this.$emit("lookDetail", codeId, this.isFundShow);
    },
  },
};
</script>


<style scoped>
.title {
  margin: 20px 0px;
}
.table-item {
  margin-bottom: 20px;
}
/* .el-tag {
  color: #3165ff;
  background: #dde6ff;
} */
.el-tag.el-tag--warning {
  border-color: #fff !important;
}
</style>

